module.exports = __webpack_public_path__ + "static/img/hyundai-partecs-thumb.913554b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/hyundai-partecs-thumb.jpg
// module id = 9bB9
// module chunks = 0